import React from 'react';
import { Link } from 'react-router-dom';

const carCameraSvg = `<svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.296 14.0939C13.9707 14.0939 15.3284 12.8164 15.3284 11.2406C15.3284 9.66468 13.9707 8.38718 12.296 8.38718C10.6213 8.38718 9.26367 9.66468 9.26367 11.2406C9.26367 12.8164 10.6213 14.0939 12.296 14.0939Z" fill="white"></path><path d="M9.45163 2.32436L7.71751 4.10772H4.71358C3.67121 4.10772 2.81836 4.91023 2.81836 5.89108V16.5913C2.81836 17.5721 3.67121 18.3746 4.71358 18.3746H19.8754C20.9177 18.3746 21.7706 17.5721 21.7706 16.5913V5.89108C21.7706 4.91023 20.9177 4.10772 19.8754 4.10772H16.8714L15.1373 2.32436H9.45163ZM12.2945 15.6996C9.67906 15.6996 7.55641 13.7022 7.55641 11.2412C7.55641 8.78013 9.67906 6.78276 12.2945 6.78276C14.9099 6.78276 17.0325 8.78013 17.0325 11.2412C17.0325 13.7022 14.9099 15.6996 12.2945 15.6996Z" fill="white"></path></svg>`;

const cars = [
  {
    name: 'Swift Dezire',
    type: 'Sedan',
    fuel: 'Petrol/Diesel',
    seating: '4+1',
    transmission: 'Manual/Auto',
    image: '/assets/img/car/dzire.png',
    link: '/swift-dzire'
  },
  {
    name: 'Maruti Ertiga XUV',
    type: 'MUV',
    fuel: 'Petrol/CNG',
    seating: '6+1',
    transmission: 'Manual/Auto',
    image: '/assets/img/car/ertiga.png',
    link: '/maruti-ertiga'
  },
  {
    name: 'Innova Crysta',
    type: 'MPV',
    fuel: 'Diesel',
    seating: '7+1',
    transmission: 'Manual/Auto',
    image: '/assets/img/car/crysta.png',
    link: '/innova-crysta'
  },
  {
    name: 'Force Urbania',
    type: 'Luxury Van',
    fuel: 'Diesel',
    seating: '13+1',
    transmission: 'Manual',
    image: '/assets/img/car/arban.jpg',
    link: '/force-urbania'
  },
  {
    name: 'Tempo Traveller',
    type: 'Mini Bus',
    fuel: 'Diesel',
    seating: '17+1',
    transmission: 'Manual',
    image: '/assets/img/car/traveller.png',
    link: '/tempo-traveller'
  },
  {
    name: '56-Seater Bus',
    type: 'Bus',
    fuel: 'Diesel',
    seating: '56',
    transmission: 'Manual',
    image: '/assets/img/car/bus.png',
    link: '/bus-56seater'
  }
];

const brands = [
  { name: 'Acura', image: '/assets/img/brand/1.png' },
  { name: 'Ford', image: '/assets/img/brand/2.png' },
  { name: 'Bentley', image: '/assets/img/brand/3.png' },
  { name: 'Cheavrolet', image: '/assets/img/brand/4.png' },
  { name: 'Ferrari', image: '/assets/img/brand/5.png' },
  { name: 'Mercedes', image: '/assets/img/brand/6.png' }
];

const Home = () => {
  return (
    <>
      {/* Slide */}
      <div className="widget-tf-slider">
        <div className="slider-wrap swiper-wrapper">
          <div className="tf-slide-item swiper-slide">
            <div className="slide-item-image">
              <img src="/assets/img/bg.jpg" alt="Car Rental Services in Rajkot - Cab Experience" />
              <div className="overlay"></div>
            </div>
            <div className="slide-item-content">
              <div className="slide-content">
                <span className="wow fadeInUp sub-title" data-wow-delay="100ms" data-wow-duration="2000ms">
                  Trusted Car Rental Service in Rajkot
                </span>
                <h1 className="title-slide wow slideInUp" data-wow-delay="50ms" data-wow-duration="200ms">
                  Premium Car Rental in Rajkot - Cab Experience
                </h1>
                <p className="description wow fadeInUp" data-wow-delay="300ms" data-wow-duration="2000ms">
                  Book premium cars in Rajkot for weddings, outstation trips, airport transfers & city tours.
                  Swift Dzire, Innova Crysta, Ertiga, Tempo Traveller available at affordable rates with 24/7 service.
                </p>
                <div className="box">
                  <div className="btn-main wow fadeInUp" data-wow-delay="400ms" data-wow-duration="2000ms">
                    <Link to="/book-a-car" className="button_main_inner">
                      <span>Go to Booking</span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="slide-image">
                <img src="/assets/images/slide/icon.png" className="icon-shape wow swing" alt="" />
                <div className="box-car">
                  <img src="/assets/img/car.png" alt="" />
                </div>
              </div>
              <div className="box">
                <span>+91 7801904444</span>
                <span>info@cabexperience.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Widget Tab Car Service */}
      <div className="widget-car-service">
        <div className="themesflat-container">
          <div className="header-section tab-car-service">
            <div className="heading-section">
              <span className="sub-title mb-6 wow fadeInUp">Trusted Car Rental Service in Rajkot</span>
              <h2 className="title wow fadeInUp">Explore Our Premium Car Collection</h2>
            </div>
            <ul className="nav nav-pills justify-content-end" id="pills-tab-service" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active" type="button">All Cars</button>
              </li>
            </ul>
          </div>
          <div className="tab-content" id="pills-tabContent">
            <div className="tab-pane fade show active" id="pills-home-service" role="tabpanel">
              <div className="car-list-item">
                {cars.map((car, index) => (
                  <div key={index} className="tf-car-service">
                    <Link to={car.link} className="image">
                      <div className="stm-badge-top">
                        <div className="feature">
                          <span>Featured</span>
                        </div>
                      </div>
                      <div className="listing-images">
                        <div className="hover-listing-image">
                          <div className="wrap-hover-listing">
                            <div className="listing-item active" title={car.name}>
                              <div className="images">
                                <img src={car.image} className="swiper-image tfcl-light-gallery" alt={car.name} />
                              </div>
                            </div>
                            <div className="bullet-hover-listing">
                              <div className="bl-item active"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                    <div className="content">
                      <h6 className="title">
                        <Link to={car.link}>{car.name}</Link>
                      </h6>
                      <span className="price">{car.price}</span>
                      <div className="description">
                        <ul>
                          <li className="listing-information fuel">
                            <i className="icon-gasoline-pump-1"></i>
                            <div className="inner">
                              <span>Fuel type</span>
                              <p>{car.fuel}</p>
                            </div>
                          </li>
                          <li className="listing-information size-engine">
                            <i className="icon-Group1"></i>
                            <div className="inner">
                              <span>Seating</span>
                              <p>{car.seating}</p>
                            </div>
                          </li>
                          <li className="listing-information transmission">
                            <i className="icon-gearbox-1"></i>
                            <div className="inner">
                              <span>Transmission</span>
                              <p>{car.transmission}</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="bottom-btn-wrap">
                        <div className="btn-read-more">
                          <Link className="more-link" to={car.link}>
                            <span>View details</span>
                            <i className="icon-arrow-right2"></i>
                          </Link>
                        </div>
                        <div className="btn-group">
                          <a href="#" className="icon-service">
                            <i className="icon-shuffle-2-11"></i>
                          </a>
                          <a href="#" className="icon-service">
                            <i className="icon-heart-1-1"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Service Area Section - SEO Optimized */}
      <section style={{ padding: '60px 0', background: '#1a1a2e' }}>
        <div className="themesflat-container">
          <div className="heading-section t-al-center mb-40">
            <span style={{ color: '#edb808', fontSize: '14px', fontWeight: '600', letterSpacing: '2px', textTransform: 'uppercase', display: 'block', marginBottom: '10px' }}>
              Service Coverage
            </span>
            <h2 style={{ color: 'white', fontSize: '36px', fontWeight: '700', marginBottom: '15px' }}>
              Car Rental Service Areas from Rajkot
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px', maxWidth: '600px', margin: '0 auto', lineHeight: '1.7' }}>
              We provide premium car rental services from Rajkot to all major destinations across Gujarat and beyond.
            </p>
          </div>
          
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '15px', maxWidth: '1000px', margin: '0 auto' }}>
            {[
              { route: 'Rajkot Hirasar Airport to Rajkot', keywords: 'car rental Hirasar Airport, taxi service rajkot Hirasar Airport Texi' },
              { route: 'Rajkot to Morbi', keywords: 'car rental morbi, taxi service rajkot morbi' },
              { route: 'Rajkot to Surat', keywords: 'surat car rental, rajkot surat taxi' },
              { route: 'Rajkot to Ahmedabad', keywords: 'ahmedabad car rental, rajkot ahmedabad cab' },
              { route: 'Rajkot to Junagadh', keywords: 'junagadh taxi, rajkot junagadh car rental' },
              { route: 'Rajkot to Somnath', keywords: 'somnath taxi, dwarka somnath tour package' },
              { route: 'Rajkot to Dwarka', keywords: 'dwarka car rental, rajkot dwarka cab' },
              { route: 'Rajkot to Jamnagar', keywords: 'jamnagar taxi, rajkot jamnagar rental' },
              { route: 'Rajkot to Bhavnagar', keywords: 'bhavnagar car rental, rajkot bhavnagar taxi' },
              { route: 'Rajkot to Vadodara', keywords: 'vadodara cab rental, rajkot vadodara taxi' },
              { route: 'Rajkot to Bhuj', keywords: 'bhuj car rental, kutch bhuj taxi service' },
              { route: 'Rajkot to Bharuch', keywords: 'bharuch taxi, rajkot bharuch cab' },
              { route: 'Rajkot to Gandhidham', keywords: 'gandhidham car rental, rajkot gandhidham taxi' },
              { route: 'Rajkot to Diu', keywords: 'diu beach tour, rajkot diu cab' },
              { route: 'Rajkot to Porbandar', keywords: 'porbandar taxi, birth place of mahatma gandhi' },
              { route: 'Rajkot to Vapi', keywords: 'vapi car rental, gujarat industrial area taxi' },
              { route: 'Rajkot to Mumbai', keywords: 'mumbai car rental, rajkot mumbai outstation cab' },
              { route: 'Rajkot to Rajula', keywords: 'rajula taxi, amreli district car rental' }
            ].map((item, index) => (
              <a 
                key={index}
                href={`/book-a-car?route=${encodeURIComponent(item.route)}`}
                title={item.keywords}
                style={{
                  display: 'inline-block',
                  padding: '12px 24px',
                  background: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '50px',
                  color: 'white',
                  textDecoration: 'none',
                  fontSize: '15px',
                  fontWeight: '500',
                  transition: 'all 0.3s ease',
                  textAlign: 'center'
                }}
                onMouseOver={(e) => {
                  e.target.style.background = '#edb808';
                  e.target.style.borderColor = '#edb808';
                  e.target.style.color = '#1a1a2e';
                }}
                onMouseOut={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.05)';
                  e.target.style.borderColor = 'rgba(255,255,255,0.1)';
                  e.target.style.color = 'white';
                }}
              >
                {item.route}
              </a>
            ))}
          </div>
          
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px' }}>
              Call us at <a href="tel:+917801904444" style={{ color: '#edb808', textDecoration: 'none' }}>+91 7801904444</a> for custom routes and special bookings
            </p>
          </div>
        </div>
      </section>

         {/* Why Choose Us Section */}
      <div className="widget-icon-box" style={{ padding: '80px 0', backgroundColor: '#f8f9fa' }}>
        <div className="themesflat-container">
          <div className="heading-section t-al-center mb-30">
            <h2 className="title">Why Choose Cab Experience?</h2>
          </div>
          <div className="row">
            {[
              { icon: 'icon-Vector-32', title: 'Best Rates', desc: 'Competitive pricing without compromising on quality' },
              { icon: 'icon-Vector-32', title: '24/7 Support', desc: 'Round-the-clock customer support for your peace of mind' },
              { icon: 'icon-Vector-32', title: 'Professional Drivers', desc: 'Courteous and experienced drivers trained for your safety' },
              { icon: 'icon-Vector-32', title: 'Well Maintained', desc: 'All vehicles regularly serviced and maintained' }
            ].map((item, index) => (
              <div key={index} className="col-lg-3 col-md-6 col-12 mb-30">
                <div className="feature-box" style={{ padding: '30px', textAlign: 'center' }}>
                  <i className={item.icon} style={{ fontSize: '40px', color: '#d32f2f', marginBottom: '15px', display: 'block' }}></i>
                  <h4 className="mb-10">{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Hirasar Airport Pickup & Drop Section - Professional Design */}
      <section className="airport-service-section" style={{ 
        padding: '80px 0', 
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Background Pattern */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url('/assets/img/airport/h1.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.1
        }}></div>
        
        <div className="themesflat-container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="row align-items-center">
            {/* Left Side - Content */}
            <div className="col-lg-6 col-md-12">
              <div className="airport-content" style={{ padding: '20px' }}>
                {/* Trending Badge */}
                <div className="trending-badge" style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  background: 'linear-gradient(135deg, #edb808 0%, #f5c518 100%)',
                  padding: '8px 16px',
                  borderRadius: '50px',
                  marginBottom: '20px',
                  animation: 'pulse 2s infinite'
                }}>
                  <span style={{ fontSize: '16px' }}>🔥</span>
                  <span style={{ color: '#1a1a2e', fontWeight: '700', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '1px' }}>Cab Experience</span>
                </div>
                
                {/* Main Heading */}
                <h2 style={{
                  color: 'white',
                  fontSize: '42px',
                  fontWeight: '800',
                  marginBottom: '15px',
                  lineHeight: '1.2'
                }}>
                  Rajkot <span style={{ color: '#edb808' }}>Hirasar Airport</span> <br />
                  Pickup & Drop Facility
                </h2>
                
                {/* Subtitle */}
                <p style={{
                  color: 'rgba(255,255,255,0.85)',
                  fontSize: '17px',
                  marginBottom: '30px',
                  lineHeight: '1.8'
                }}>
                  Experience seamless airport transfers with Cab Experience. We provide reliable, comfortable, and affordable pickup and drop services from Rajkot Hirasar Airport to Rajkot city and vice versa.
                </p>
                
                {/* Features List */}
                <div className="features-list" style={{ marginBottom: '35px' }}>
                  {[
                    { icon: '🚗', text: 'Professional & Verified Drivers' },
                    { icon: '⏰', text: '24/7 Available - Early Morning & Late Night Flights' },
                    { icon: '📍', text: 'Flight Tracking - We Monitor Your Flight Status' },
                    { icon: '💰', text: 'Transparent Pricing - No Hidden Charges' },
                    { icon: '🧳', text: 'Luggage Assistance & Care' },
                    { icon: '🔒', text: 'Safe & Comfortable Journey Guaranteed' }
                  ].map((feature, index) => (
                    <div 
                      key={index} 
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        marginBottom: '15px',
                        color: 'white'
                      }}
                    >
                      <span style={{ fontSize: '20px' }}>{feature.icon}</span>
                      <span style={{ fontSize: '15px', fontWeight: '500' }}>{feature.text}</span>
                    </div>
                  ))}
                </div>
                
                {/* Stats Row */}
                <div className="stats-row" style={{ 
                  display: 'flex', 
                  gap: '30px', 
                  marginBottom: '35px',
                  flexWrap: 'wrap'
                }}>
                  {[
                    { number: '5000+', label: 'Happy Travelers' },
                    { number: '99%', label: 'On-Time Delivery' },
                    { number: '4.9★', label: 'Customer Rating' }
                  ].map((stat, index) => (
                    <div key={index} style={{ textAlign: 'left' }}>
                      <div style={{ 
                        fontSize: '32px', 
                        fontWeight: '800', 
                        color: '#edb808',
                        lineHeight: '1'
                      }}>{stat.number}</div>
                      <div style={{ 
                        color: 'rgba(255,255,255,0.7)', 
                        fontSize: '13px',
                        marginTop: '5px'
                      }}>{stat.label}</div>
                    </div>
                  ))}
                </div>
                
                {/* CTA Buttons */}
                <div className="cta-buttons" style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                  <Link 
                    to="/book-a-car?route=Rajkot Hirasar Airport to Rajkot"
                    className="button_main_inner"
                    style={{
                      background: '#edb808',
                      color: '#1a1a2e',
                      padding: '16px 32px',
                      fontWeight: '700',
                      fontSize: '15px'
                    }}
                  >
                    <span>Book Airport Taxi</span>
                  </Link>
                  <a 
                    href="tel:+917801904444"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '16px 28px',
                      border: '2px solid rgba(255,255,255,0.3)',
                      borderRadius: '8px',
                      color: 'white',
                      textDecoration: 'none',
                      fontWeight: '600',
                      fontSize: '15px',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.borderColor = '#edb808';
                      e.target.style.color = '#edb808';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.borderColor = 'rgba(255,255,255,0.3)';
                      e.target.style.color = 'white';
                    }}
                  >
                    <span>📞</span> Call Now
                  </a>
                </div>
              </div>
            </div>
            
            {/* Right Side - Images */}
            <div className="col-lg-6 col-md-12">
              <div className="airport-images" style={{ 
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '20px',
                padding: '20px'
              }}>
                {/* Main Image */}
                <div style={{ 
                  gridColumn: 'span 2',
                  position: 'relative',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: '0 20px 50px rgba(0,0,0,0.3)'
                }}>
                  <img 
                    src="/assets/img/airport/4.jpg" 
                    alt="Hirasar Airport Terminal Building"
                    style={{ 
                      width: '100%', 
                      height: '280px',
                      objectFit: 'cover'
                    }} 
                  />
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '20px',
                    background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                    color: 'white'
                  }}>
                    <h4 style={{ margin: 0, fontSize: '18px', fontWeight: '700' }}>Hirasar International Airport</h4>
                    <p style={{ margin: '5px 0 0', fontSize: '14px', opacity: 0.8 }}>Modern Terminal Building</p>
                  </div>
                </div>
                
                {/* Secondary Image 1 */}
                <div style={{ 
                  position: 'relative',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: '0 20px 50px rgba(0,0,0,0.3)'
                }}>
                  <img 
                    src="/assets/img/airport/3.jpg" 
                    alt="Rajkot Airport Transfer"
                    style={{ 
                      width: '100%', 
                      height: '200px',
                      objectFit: 'cover'
                    }} 
                  />
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '15px',
                    background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                    color: 'white'
                  }}>
                    <h5 style={{ margin: 0, fontSize: '15px', fontWeight: '600' }}>Rajkot City</h5>
                    <p style={{ margin: '3px 0 0', fontSize: '12px', opacity: 0.8 }}>Doorstep Pickup</p>
                  </div>
                </div>
                
                {/* Secondary Image 2 */}
                <div style={{ 
                  position: 'relative',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: '0 20px 50px rgba(0,0,0,0.3)'
                }}>
                  <img 
                    src="/assets/img/airport/h2.webp" 
                    alt="Premium Car Airport Transfer"
                    style={{ 
                      width: '100%', 
                      height: '200px',
                      objectFit: 'cover'
                    }} 
                  />
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '15px',
                    background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                    color: 'white'
                  }}>
                    <h5 style={{ margin: 0, fontSize: '15px', fontWeight: '600' }}>Premium Fleet</h5>
                    <p style={{ margin: '3px 0 0', fontSize: '12px', opacity: 0.8 }}>Swift Dzire to Innova Crysta</p>
                  </div>
                </div>
              </div>
              
              {/* Info Card */}
              <div style={{
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(10px)',
                borderRadius: '12px',
                padding: '20px',
                margin: '0 20px 20px',
                border: '1px solid rgba(255,255,255,0.1)'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <div style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    background: '#edb808',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px'
                  }}>✈️</div>
                  <div>
                    <h5 style={{ color: 'white', margin: '0 0 5px', fontSize: '16px', fontWeight: '700' }}>Hirasar Airport to Rajkot City</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Custom Styles */}
        <style>{`
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }
          .airport-service-section .button_main_inner:hover {
            transform: translateY(-3px);
            box-shadow: 0 10px 30px rgba(237, 184, 8, 0.4);
          }
        `}</style>
      </section>

      {/* Our Services Section - SEO Optimized */}
      <section className="services-section" style={{ padding: '80px 0', background: '#ffffff' }}>
        <div className="themesflat-container">
          <div className="heading-section t-al-center mb-50">
            <span className="sub-title mb-6 wow fadeInUp" style={{ color: '#edb808', fontWeight: '600', letterSpacing: '2px', textTransform: 'uppercase', fontSize: '14px' }}>
              Our Services
            </span>
            <h2 className="title wow fadeInUp" style={{ fontSize: '42px', fontWeight: '800', color: '#1a1a2e', marginBottom: '15px' }}>
              Professional Car Rental Services in Rajkot
            </h2>
            <p className="description wow fadeInUp" style={{ maxWidth: '700px', margin: '0 auto', color: '#666', fontSize: '16px', lineHeight: '1.8' }}>
              We offer premium car rental solutions for all your travel needs. From airport transfers to wedding celebrations, our professional fleet ensures comfortable and safe journeys across Gujarat and beyond.
            </p>
          </div>
          
          <div className="row">
            {/* Airport Transfer Service */}
            <div className="col-lg-4 col-md-6 mb-30">
              <div className="service-card" style={{ 
                background: 'white', 
                borderRadius: '16px', 
                padding: '35px 30px',
                boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                height: '100%',
                border: '1px solid #f0f0f0'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.12)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.08)';
              }}>
                <div style={{ 
                  width: '70px', 
                  height: '70px', 
                  borderRadius: '50%', 
                  background: 'linear-gradient(135deg, #edb808 0%, #f5c518 100%)',
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  marginBottom: '25px',
                  fontSize: '32px'
                }}>✈️</div>
                <h3 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '15px', color: '#1a1a2e' }}>
                  Airport Transfer Rajkot
                </h3>
                <p style={{ color: '#666', fontSize: '15px', lineHeight: '1.8', marginBottom: '20px' }}>
                  Reliable pickup and drop services from <strong>Rajkot Hirasar Airport</strong> to Rajkot city and all major destinations. We track flight schedules for punctual service.
                </p>
                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 25px' }}>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Hirasar Airport to Rajkot
                  </li>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Rajkot to Hirasar Airport
                  </li>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> 24/7 Flight Monitoring
                  </li>
                </ul>
                <Link to="/book-a-car?route=Rajkot Hirasar Airport to Rajkot" style={{ 
                  color: '#edb808', 
                  fontWeight: '600', 
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  Book Airport Taxi <span>→</span>
                </Link>
              </div>
            </div>
            
            {/* Wedding Car Rental */}
            <div className="col-lg-4 col-md-6 mb-30">
              <div className="service-card" style={{ 
                background: 'white', 
                borderRadius: '16px', 
                padding: '35px 30px',
                boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                height: '100%',
                border: '1px solid #f0f0f0'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.12)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.08)';
              }}>
                <div style={{ 
                  width: '70px', 
                  height: '70px', 
                  borderRadius: '50%', 
                  background: 'linear-gradient(135deg, #edb808 0%, #f5c518 100%)',
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  marginBottom: '25px',
                  fontSize: '32px'
                }}>💒</div>
                <h3 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '15px', color: '#1a1a2e' }}>
                  Wedding Car Rental Rajkot
                </h3>
                <p style={{ color: '#666', fontSize: '15px', lineHeight: '1.8', marginBottom: '20px' }}>
                  Make your special day memorable with our premium wedding car rental services. Luxury cars, decorators, and professional drivers included.
                </p>
                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 25px' }}>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Luxury Wedding Cars
                  </li>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Flower Decoration
                  </li>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Experienced Chauffeurs
                  </li>
                </ul>
                <Link to="/book-a-car?service=wedding" style={{ 
                  color: '#edb808', 
                  fontWeight: '600', 
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  Book Wedding Car <span>→</span>
                </Link>
              </div>
            </div>
            
            {/* Outstation Trips */}
            <div className="col-lg-4 col-md-6 mb-30">
              <div className="service-card" style={{ 
                background: 'white', 
                borderRadius: '16px', 
                padding: '35px 30px',
                boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                height: '100%',
                border: '1px solid #f0f0f0'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.12)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.08)';
              }}>
                <div style={{ 
                  width: '70px', 
                  height: '70px', 
                  borderRadius: '50%', 
                  background: 'linear-gradient(135deg, #edb808 0%, #f5c518 100%)',
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  marginBottom: '25px',
                  fontSize: '32px'
                }}>🗺️</div>
                <h3 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '15px', color: '#1a1a2e' }}>
                  Outstation Taxi Rajkot
                </h3>
                <p style={{ color: '#666', fontSize: '15px', lineHeight: '1.8', marginBottom: '20px' }}>
                  Explore Gujarat and beyond with our comfortable outstation taxi services. Popular destinations: Somnath, Dwarka, Diu, Mumbai, Ahmedabad & more.
                </p>
                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 25px' }}>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> One-way & Round-trip
                  </li>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Well-maintained Fleet
                  </li>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Flexible Pricing
                  </li>
                </ul>
                <Link to="/book-a-car?service=outstation" style={{ 
                  color: '#edb808', 
                  fontWeight: '600', 
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  Book Outstation Trip <span>→</span>
                </Link>
              </div>
            </div>
            
            {/* City Tour */}
            <div className="col-lg-4 col-md-6 mb-30">
              <div className="service-card" style={{ 
                background: 'white', 
                borderRadius: '16px', 
                padding: '35px 30px',
                boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                height: '100%',
                border: '1px solid #f0f0f0'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.12)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.08)';
              }}>
                <div style={{ 
                  width: '70px', 
                  height: '70px', 
                  borderRadius: '50%', 
                  background: 'linear-gradient(135deg, #edb808 0%, #f5c518 100%)',
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  marginBottom: '25px',
                  fontSize: '32px'
                }}>🏙️</div>
                <h3 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '15px', color: '#1a1a2e' }}>
                  Rajkot City Tour
                </h3>
                <p style={{ color: '#666', fontSize: '15px', lineHeight: '1.8', marginBottom: '20px' }}>
                  Discover Rajkot's attractions with our comfortable city tour packages. Visit Watson Museum, Rotary Dolls Museum, Ramkund & more.
                </p>
                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 25px' }}>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Customizable Itinerary
                  </li>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Professional Guides
                  </li>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Affordable Packages
                  </li>
                </ul>
                <Link to="/book-a-car?service=city-tour" style={{ 
                  color: '#edb808', 
                  fontWeight: '600', 
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  Book City Tour <span>→</span>
                </Link>
              </div>
            </div>
            
            {/* Corporate Rental */}
            <div className="col-lg-4 col-md-6 mb-30">
              <div className="service-card" style={{ 
                background: 'white', 
                borderRadius: '16px', 
                padding: '35px 30px',
                boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                height: '100%',
                border: '1px solid #f0f0f0'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.12)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.08)';
              }}>
                <div style={{ 
                  width: '70px', 
                  height: '70px', 
                  borderRadius: '50%', 
                  background: 'linear-gradient(135deg, #edb808 0%, #f5c518 100%)',
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  marginBottom: '25px',
                  fontSize: '32px'
                }}>🏢</div>
                <h3 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '15px', color: '#1a1a2e' }}>
                  Corporate Car Rental
                </h3>
                <p style={{ color: '#666', fontSize: '15px', lineHeight: '1.8', marginBottom: '20px' }}>
                  Business travel solutions for corporates in Rajkot. Employee transport, client visits, and executive car services with professional drivers.
                </p>
                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 25px' }}>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Monthly Contracts
                  </li>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Executive Fleet
                  </li>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Invoice Billing
                  </li>
                </ul>
                <Link to="/book-a-car?service=corporate" style={{ 
                  color: '#edb808', 
                  fontWeight: '600', 
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  Corporate Booking <span>→</span>
                </Link>
              </div>
            </div>
            
            {/* Event Transportation */}
            <div className="col-lg-4 col-md-6 mb-30">
              <div className="service-card" style={{ 
                background: 'white', 
                borderRadius: '16px', 
                padding: '35px 30px',
                boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                height: '100%',
                border: '1px solid #f0f0f0'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.12)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.08)';
              }}>
                <div style={{ 
                  width: '70px', 
                  height: '70px', 
                  borderRadius: '50%', 
                  background: 'linear-gradient(135deg, #edb808 0%, #f5c518 100%)',
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  marginBottom: '25px',
                  fontSize: '32px'
                }}>🎉</div>
                <h3 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '15px', color: '#1a1a2e' }}>
                  Event Transportation
                </h3>
                <p style={{ color: '#666', fontSize: '15px', lineHeight: '1.8', marginBottom: '20px' }}>
                  Group transportation for events, parties, gatherings, and celebrations in Rajkot. Tempo Traveller and large fleet available.
                </p>
                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 25px' }}>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Group Discounts
                  </li>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> Multi-stop Routes
                  </li>
                  <li style={{ padding: '8px 0', color: '#444', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ color: '#edb808' }}>✓</span> 24/7 Support
                  </li>
                </ul>
                <Link to="/book-a-car?service=event" style={{ 
                  color: '#edb808', 
                  fontWeight: '600', 
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  Book Event Transport <span>→</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <div style={{ padding: '60px 0', textAlign: 'center' }}>
        <div className="themesflat-container">
          <h2 className="title mb-20">Ready to Book Your Car?</h2>
          <p className="description mb-30">Get the best car rental experience in Rajkot. Book now and enjoy premium service!</p>
          <Link to="/book-a-car" className="button_main_inner">
            <span>Book Now</span>
          </Link>
        </div>
      </div>

      {/* WhatsApp Float Button */}
      <div className="whatsappbar">
        <ul>
          <li>
            <a href="https://wa.me/917801904444" target="_blank" rel="noopener noreferrer">
              <i className="icon-whatsapp-1"></i>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Home;
